import { handleImageError } from "@/utils/GalleryFunctions";
import "./Comment.scss";
import { SetStateAction, useState } from "react";
import NewComment from "../NewComment/NewComment";
import { commentDate } from "@/utils/DateFormats";
import { ReportedElementI } from "@/interfaces/galleries/Galleries";
import { usePhotoViewContext } from "@/context/PhotoViewContext";
import { useGalleryContext } from "@/context/GalleryContext";
import { useRouter } from "next/navigation";

interface CommentPropsI {
  comment: any;
  level?: number;
  viewOnly?: boolean;
  setReport?: React.Dispatch<
    SetStateAction<{ show: boolean; reportedElement: ReportedElementI | null }>
  >;
}

function Comment(props: CommentPropsI) {
  const [reply, setReply] = useState<boolean>(false);
  const router = useRouter();

  const { photo } = usePhotoViewContext();
  const { gallery } = useGalleryContext();
  const { comment, level, viewOnly, setReport } = props;

  const navigateProfile = () => {
    if (comment.userId && comment.userId.name) {
      router.push("/profile?user=" + comment.userId.name);
    }
  };

  return (
    <div
      className="comment-component-main-container"
      style={viewOnly ? { width: 450 } : {}}
    >
      <div className="main-commment-container">
        <img
          src={comment.userId ? comment.userId.avatar : ""}
          onError={handleImageError}
          onClick={navigateProfile}
          alt="user avatar"
        />
        <div className="comment-info-container">
          <div className="c-row">
            <h3>
              {comment.userId?.name || "Account deleted"}{" "}
              {comment.userId?.admin > 0 ? "(Moderator)" : ""}
            </h3>
          </div>
          <div className="c-row">
            <h4 className="font-light">{comment.comment}</h4>
          </div>
          <div className="c-row">
            <p>
              <span className="points-text">{comment.userId?.points}</span>{" "}
              points
            </p>
            <p>{commentDate(comment.createdAt)}</p>
            {!viewOnly && (
              <>
                {(!level || level < 3) && (
                  <h5 role="button" onClick={() => setReply(!reply)}>
                    Reply
                  </h5>
                )}
                {setReport && (
                  <h5
                    role="button"
                    onClick={() =>
                      setReport({
                        show: true,
                        reportedElement: {
                          id: comment._id,
                          galleryId: gallery!._id,
                          type: "comment",
                          url: photo!.url,
                        },
                      })
                    }
                  >
                    Report
                  </h5>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="reply-container">
        {reply && (
          <NewComment photoId={comment.photoId} parentCommentId={comment._id} />
        )}
      </div>
      <div className="sub-comments-container">
        {comment.subComment?.map((subComment: any, i: any) => {
          return (
            <Comment
              setReport={setReport}
              comment={subComment}
              level={(level ? level : 1) + 1}
              key={`sub-comment-${i}`}
              viewOnly={viewOnly}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Comment;
